import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addFaq } from "../../Adapters/ApiAdapter";
import { useNavigate } from "react-router-dom";

const AddFaq = () => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!question.trim() || !answer.trim()) {
      toast.error("Both Question and Answer fields are required!");
      return;
    }

    setLoading(true);

    const faqData = {
      question: question.trim(),
      answer: answer.trim(),
    };

    try {
      const response = await addFaq(faqData);

      console.log("API Response:", response); // Debugging

      // Check if the response contains a success message and no errors
      if (response && response.status === "true") {
        toast.success("FAQ Added successfully!", {
          autoClose: 3000,
          onClose: () => navigate("/faq-list"),
        });

        setQuestion("");
        setAnswer("");
      } else {
        toast.error(
          response?.message || "Failed to add FAQ. Please try again."
        );
      }
    } catch (error) {
      console.error("Error adding FAQ:", error);
      toast.error(error?.message || "An error occurred while adding FAQ.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add FAQ
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        gap="16px"
        maxWidth="600px"
        mt="20px"
      >
        <TextField
          label="Question"
          variant="outlined"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          fullWidth
          required
        />
        <TextField
          label="Answer"
          variant="outlined"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          multiline
          rows={5}
          fullWidth
          required
        />
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Add FAQ"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddFaq;
